
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { checkIfSectionTitleIsDeletable } from '../../../../utils/editor.util';

@Component({})
export default class StagingEditorSectionCard extends Vue {
  @Prop(String) public text!: string;
  @Prop(Boolean) public draggable!: boolean;
  @Prop({ default: false }) public hasError!: boolean;

  public handleClick() {
    // scroll section into view
    const i = [
      ...document.querySelectorAll('.' + this.$style.sectionCard)
    ].findIndex((e) => e === this.$refs.sectionCard);
    const target = document.querySelectorAll('.section-title-editor')[i];
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Allow deletion of non default section titles
  public checkIfDeletable() {
    return checkIfSectionTitleIsDeletable(this.text);
  }
}
